import React from "react";
import Wrapper from '../mathOperatorwrapper';
import ButtonBox from '../mathOperatorButtonBox';
import Button from '../mathOperatorButton';

const btnValues = [
    [7, 8, 9, "÷", "√", "^²"],
    [4, 5, 6, "x", "(", ")"],
    [1, 2, 3, "-", "Add Field"],
    [0, "00", ".", "+", "Done"],
];

function MathOperator(props:any) {
    const {state,handleState} = props
    console.log(state)
    return (
        <div className="App">

            <Wrapper>
                <ButtonBox>
                    {
                        btnValues.flat().map((btn, i) => {
                            return (
                                <Button
                                    key={i}
                                    className={["Add Field", "Done"].includes(`${btn}`) ? "bigButton" : ""}
                                    value={btn}
                                    onClick={() => {
                                        handleState(state+String(btn), "child")
                                    }}
                                />
                            );
                        })
                    }
                </ButtonBox>
            </Wrapper>
        </div>
    );
}

export default MathOperator;
